import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";

const ShowIncomeLabelContext = createContext<ShowIncomeLabelContextValue | undefined>(undefined);

interface ShowIncomeLabelContextValue {
    showIncomeLabel: boolean;
    setShowIncomeLabel: (value: boolean) => void;
}

interface ShowIncomeLabelProviderProps {
    children: ReactNode;
    initialState: boolean;
}

export const ShowIncomeLabelProvider = (props: ShowIncomeLabelProviderProps) => {
    const [showIncomeLabel, setShowIncomeLabel] = useState(props.initialState)

    useEffect(() => {
        setShowIncomeLabel(props.initialState)
    }, [props.initialState])

    return (
        <ShowIncomeLabelContext.Provider value={{ showIncomeLabel, setShowIncomeLabel }}>
            {props.children}
        </ShowIncomeLabelContext.Provider>
    )
}

export const useShowIncomeLabel = (): ShowIncomeLabelContextValue => {
    const context = useContext(ShowIncomeLabelContext)
    if (!context) {
        return {
            showIncomeLabel: true,
            setShowIncomeLabel: () => undefined
        }
    }
    return context
}